// export type CreditCardFlag = "electron" | "maestro" | "dankort" | "interpayment" | "unionpay" |
// "visa" | "mastercard" | "amex" | "diners" | "discover" | "jcb";

import creditCardType from "credit-card-type";

export enum CreditCardFlag {
	Visa = "visa",
	Mastercard = "mastercard",
	Amex = "american-express",
	Diners = "diners-club",
	Discover = "discover",
	Jcb = "jcb",
	Unionpay = "unionpay",
	Maestro = "maestro",
	Mir = "mir",
	Elo = "elo",
	Hipercard = "hipercard",
	Interpayment = "interpayment",
}

export const getCreditCardFlag = (creditCardNumber: string | number): CreditCardFlag | undefined => {
	const creditCardList = creditCardType(creditCardNumber.toString());
	if (!creditCardList) return undefined;
	if (creditCardList.length == 0) return undefined;
	return creditCardList[0].type as CreditCardFlag | undefined;
};
